import { type IReactionDisposer, makeAutoObservable, reaction, runInAction } from 'mobx'
import { type IDropdownItem } from 'shared/ui'
import { type IEntitiesStore } from 'entities/EntitiesExport'
import { type IUser } from 'entities/Users'

export class MultiSelectMembersStore {
  constructor(
    readonly entities: IEntitiesStore,
    private _config?: {
      values?: number[]
      setValues?: (value: number[]) => void
      filterMembersDropdownItems?: (item: IDropdownItem<IUser>) => boolean
    }
  ) {
    if (_config?.values) {
      this.entities.usersStore.initPromise.then(() => {
        runInAction(() => {
          if (this._config?.values) {
            this.membersDropdownItems.forEach((item) => {
              if (_config?.values?.includes(Number(item.id))) {
                this._selectedMembersMap.set(Number(item.id), item)
              }
            })
            this._config.values = undefined
          }
        })
      })
    }
    this.reactionValues()
    makeAutoObservable(this)
  }

  private _disposeReactionValues: IReactionDisposer | null = null
  reactionValues = () => {
    this._disposeReactionValues?.()
    this._disposeReactionValues = reaction(
      () => this.values,
      (values) => {
        this._config?.setValues?.(values)
      }
    )
  }

  get values(): number[] {
    if (this._config?.values !== undefined) {
      return this._config?.values
    }
    return this.selectedMembers.map((item) => Number(item.id))
  }

  private _selectedMembersMap: Map<number, IDropdownItem<IUser>> = new Map()
  setSelectedMember = (item: IDropdownItem<IUser>) => {
    this._selectedMembersMap.set(Number(item.id), item)
  }
  deleteSelectedMember = (item: IDropdownItem<IUser>) => {
    this._selectedMembersMap.delete(Number(item.id))
  }
  get selectedMembers() {
    return Array.from(this._selectedMembersMap.values())
  }
  get viewSelectedMembers() {
    return this.selectedMembers.map((item) => ({
      id: item.id,
      label: item.label,
      value: item.value,
      data: {
        isAway: undefined,
        avatarInfo: item.avatarProps?.info,
      },
    }))
  }

  get membersDropdownItems(): IDropdownItem<IUser>[] {
    if (this._config?.filterMembersDropdownItems) {
      return this.entities.usersStore.membersDropdownItems.filter(
        this._config?.filterMembersDropdownItems
      )
    }
    return this.entities.usersStore.membersDropdownItems
  }
}
